(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["founders-drop-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function init(root){
    if(!root||root.__rklReady)return;root.__rklReady=true;
    var q=function(sel,scope){return (scope||root).querySelector(sel)};
    var qa=function(sel,scope){return Array.prototype.slice.call((scope||root).querySelectorAll(sel))};
    var cfg={};try{cfg=JSON.parse((q('.rkl-config')||{}).textContent||'{}')}catch(e){}
    var demo=cfg.demoMode!==false;
    var M=cfg.msg||{};
    function t(key,fallback){return M[key]||fallback}
    var motionQuery=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
    function reduced(){return !!(motionQuery&&motionQuery.matches)}

    window.dataLayer=window.dataLayer||[];
    function track(name,props){
      try{var p=Object.assign({event:'rk_'+name,ts:Date.now()},props||{});delete p.email;delete p.phone;delete p.value;delete p.e164;window.dataLayer.push(p)}catch(e){}
    }

    /* ---------- Scrolling that respects sticky theme headers ---------- */
    function headerOffset(){
      var off=0,el=document.elementFromPoint(window.innerWidth/2,2);
      while(el&&el!==document.body&&el!==document.documentElement){
        var pos=window.getComputedStyle(el).position;
        if(pos==='fixed'||pos==='sticky'){var r=el.getBoundingClientRect();if(r.top<=2&&r.bottom>0)off=Math.max(off,r.bottom)}
        el=el.parentElement;
      }
      return off;
    }
    function scrollToEl(el){
      if(!el)return;
      var top=el.getBoundingClientRect().top+window.pageYOffset-headerOffset()-12;
      window.scrollTo({top:Math.max(0,top),behavior:reduced()?'auto':'smooth'});
    }
    function scrollByInstant(d){try{window.scrollBy({top:d,left:0,behavior:'instant'})}catch(e){window.scrollBy(0,d)}}
    function ensureVisible(el){
      if(!el)return;
      var off=headerOffset(),r=el.getBoundingClientRect(),vh=window.innerHeight,d=0;
      if(r.top<off+8)d=r.top-off-12;else if(r.bottom>vh-8)d=Math.min(r.bottom-vh+16,r.top-off-12);
      if(Math.abs(d)>1)window.scrollBy({top:d,left:0,behavior:reduced()?'auto':'smooth'});
    }

    /* ---------- Layers (read from the Theme Editor blocks) ---------- */
    var fan=q('[data-fan]'),reveal=q('[data-reveal]'),stageHint=q('[data-stage-hint]');
    var cards=qa('[data-layer-card]',fan||root);
    var layers=cards.map(function(c){return{name:c.getAttribute('data-name')||'Layer',type:c.getAttribute('data-type')||'',description:c.getAttribute('data-description')||''}});
    var total=layers.length;if(!total)return;
    function two(n){return (n<10?'0':'')+n}
    function counter(i){return two(i+1)+' / '+two(total)}

    var mid=(total-1)/2;
    cards.forEach(function(c,i){
      var t=mid?(i-mid)/mid:0;
      c.style.setProperty('--t',t.toFixed(4));c.style.setProperty('--t2',(t*t).toFixed(4));
      c.style.setProperty('--z',String(20-Math.round(Math.abs(i-mid)*2)));
      if(t>0)c.setAttribute('data-side','right');
      if(Math.abs(i-mid)<.6)c.setAttribute('data-mid','');
    });

    var opened=false,selected=-1;
    function openFan(){
      if(opened||!fan)return;opened=true;fan.classList.add('is-open');
      if(reveal){reveal.setAttribute('aria-expanded','true');reveal.classList.add('is-gone');setTimeout(function(){reveal.hidden=true},260)}
      if(stageHint&&cfg.expandedHint)stageHint.textContent=cfg.expandedHint;
      track('layers_revealed',{layer_count:total});
    }
    if(reveal)reveal.addEventListener('click',function(e){e.stopPropagation();openFan()});
    if(fan)fan.addEventListener('click',function(e){if(!opened&&!e.target.closest('[data-layer-card]'))openFan()});

    var detail=q('[data-detail]'),detailName=q('[data-detail-name]'),detailType=q('[data-detail-type]'),detailDesc=q('[data-detail-description]'),detailCounter=q('[data-detail-counter]'),detailKicker=q('[data-detail-kicker]'),layerInterest=q('[data-layer-interest]');

    var pagerBtns=qa('[data-layer-step]');
    function updatePager(i){
      pagerBtns.forEach(function(b){var j=(i+Number(b.getAttribute('data-layer-step'))+total)%total,nm=q('[data-layer-step-name]',b);if(nm)nm.textContent=layers[j].name;b.setAttribute('data-target',j)});
    }
    pagerBtns.forEach(function(b){b.addEventListener('click',function(){var j=Number(b.getAttribute('data-target'));if(isFinite(j)){openLayer(j,{scroll:true,focus:true});track('layer_stepped',{direction:Number(b.getAttribute('data-layer-step'))>0?'next':'previous',layer_index:j+1})}})});
    function openLayer(i,opts){
      opts=opts||{};selected=i;var l=layers[i]||layers[0];updatePager(i);
      detailName.textContent=l.name;detailType.textContent=l.type;detailType.hidden=!l.type;
      detailDesc.textContent=l.description||t('fallbackDesc','Take a closer look. One signup covers the whole first edition.');
      detailCounter.textContent=counter(i);detailKicker.textContent=counter(i);
      if(layerInterest)layerInterest.value=l.name;
      cards.forEach(function(c,ci){if(ci===i)c.setAttribute('aria-current','true');else c.removeAttribute('aria-current')});
      detail.hidden=false;showSet(i);
      if(opts.focus&&detailName)detailName.focus({preventScroll:true});
      if(opts.scroll)scrollToEl(detail);
      track('layer_viewed',{layer_index:i+1,layer_name:l.name});
    }
    cards.forEach(function(c,i){c.addEventListener('click',function(e){e.stopPropagation();if(!opened){openFan();return}openLayer(i,{scroll:true,focus:true})})});

    function backToLayers(){
      if(signup&&!signupDone)signup.hidden=true;
      scrollToEl(fan||root);
      var c=cards[selected];if(c)c.focus({preventScroll:true});
      detail.hidden=true;
    }
    qa('[data-back-to-layers]').forEach(function(b){b.addEventListener('click',backToLayers)});

    /* ---------- Gallery: swipe (native scroll-snap), arrows, dots ---------- */
    var sets=qa('[data-gallery-set]'),dotsWrap=q('[data-gallery-dots]'),prevBtn=q('[data-gallery-prev]'),nextBtn=q('[data-gallery-next]'),controls=q('[data-gallery-controls]');
    var activeSet=null,galleryIndex=0,raf=0;
    function slidesOf(set){return set?qa('[data-gallery-slide]',set):[]}
    function updateGallery(n){
      var count=slidesOf(activeSet).length;galleryIndex=n;
      qa('.rkl-gallery__dot',dotsWrap).forEach(function(d,di){d.classList.toggle('is-active',di===n);if(di===n)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')});
      if(prevBtn)prevBtn.disabled=n<=0;if(nextBtn)nextBtn.disabled=n>=count-1;
      if(controls)controls.classList.toggle('is-single',count<2);
    }
    function goTo(n){
      var count=slidesOf(activeSet).length;if(!count)return;n=Math.max(0,Math.min(count-1,n));
      activeSet.scrollTo({left:n*activeSet.clientWidth,behavior:reduced()?'auto':'smooth'});updateGallery(n);
    }
    function showSet(i){
      sets.forEach(function(s){s.hidden=Number(s.getAttribute('data-gallery-set'))!==i});
      activeSet=sets.filter(function(s){return !s.hidden})[0]||null;if(!activeSet)return;
      qa('img',activeSet).forEach(function(img){img.loading='eager'});
      activeSet.scrollLeft=0;
      var count=slidesOf(activeSet).length;
      if(dotsWrap){dotsWrap.innerHTML='';for(var k=0;k<count;k++){(function(k){var b=document.createElement('button');b.type='button';b.className='rkl-gallery__dot';b.setAttribute('aria-label','Show image '+(k+1)+' of '+count);b.addEventListener('click',function(){goTo(k)});dotsWrap.appendChild(b)})(k)}}
      updateGallery(0);
    }
    sets.forEach(function(s){s.addEventListener('scroll',function(){if(s!==activeSet)return;cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){var n=Math.round(s.scrollLeft/Math.max(1,s.clientWidth));if(n!==galleryIndex)updateGallery(n)})},{passive:true})});
    if(prevBtn)prevBtn.addEventListener('click',function(){goTo(galleryIndex-1)});
    if(nextBtn)nextBtn.addEventListener('click',function(){goTo(galleryIndex+1)});

    /* ---------- Signup ---------- */
    var signup=q('[data-signup-section]'),form=q('[data-form]'),msg=q('[data-msg]'),sendBtn=q('[data-send-otp]'),otpBox=q('[data-otp-box]'),otpInput=q('[data-otp]'),resendBtn=q('[data-resend]'),verifyBtn=q('[data-verify]');
    var phoneInput=q('[name="phone"]'),emailInput=q('[name="email"]'),consentInput=q('[name="consent"]');
    var busy=false,otpChallenge='',verifiedToken='',sentPhone='',cooldown=0,cooldownTimer=0,webOtp=null,signupDone=false;

    qa('[data-open-signup]').forEach(function(btn){btn.addEventListener('click',function(){
      if(!signup)return;signup.hidden=false;
      if(emailInput)emailInput.focus({preventScroll:true});
      scrollToEl(signup);
      var l=layers[selected]||layers[0];track('signup_started',{layer_index:selected+1,layer_name:l.name});
    })});

    function setMsg(t,kind){if(!msg)return;msg.textContent=t||'';msg.classList.toggle('is-ok',kind==='ok')}
    function digits(v){return String(v==null?'':v).replace(/\D/g,'')}
    function normalizePhone(v){var d=digits(v);if(d.length>10&&d.indexOf('91')===0)d=d.slice(2);if(d.length===11&&d.charAt(0)==='0')d=d.slice(1);return d.slice(0,10)}
    function validPhone(d){return /^[6-9]\d{9}$/.test(d)}
    function validEmail(v){return !v||(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)&&!/\.\./.test(v)&&v.length<=254)}
    /* Junk filters ported from the first build. They stop casual fakes (and wasted OTP SMS); the OTP is what proves a number is real. */
    function uniqCount(x){var o={};for(var i=0;i<x.length;i++)o[x.charAt(i)]=1;return Object.keys(o).length}
    function repeatedBlock(x){var n=x.length,p,i,ok;if(n<4)return false;for(p=1;p<=n/2;p++){if(n%p)continue;ok=true;for(i=p;i<n;i++){if(x.charAt(i)!==x.charAt(i-p)){ok=false;break}}if(ok)return true}return false}
    function sequentialRun(x){if(x.length<4)return false;var up=true,down=true;for(var i=1;i<x.length;i++){var d=x.charCodeAt(i)-x.charCodeAt(i-1);if(d!==1)up=false;if(d!==-1)down=false}return up||down}
    var KB=['qwertyuiop','asdfghjkl','zxcvbnm','1234567890'];
    function keyboardWalk(x){if(x.length<4)return false;for(var i=0;i<KB.length;i++){var r=KB[i],rv=r.split('').reverse().join('');if(r.indexOf(x)>=0||rv.indexOf(x)>=0)return true}return false}
    function fakePhone(d){return /^(\d)\1+$/.test(d)||uniqCount(d)<=2||repeatedBlock(d)||sequentialRun(d)||keyboardWalk(d)||/^\d(\d)\1{7,}$/.test(d)}
    var JUNK=['test','tests','testing','asdf','asdfasdf','asdfg','asdfgh','qwerty','qwe','qazwsx','zxcv','abc','abcd','abcde','abcdef','xyz','fake','dummy','sample','noreply','donotreply','none','null','na','xxx','yyy','zzz'];
    var PROF_SUB=['fuck','asshole','motherf','cocksuck','dickhead','nigger','faggot','jerkoff'];
    var PROF_EXACT=['shit','dick','bitch','pussy','bastard','slut','whore','twat','wanker','bollocks','retard','dumbass','jackass','cunt'];
    function fakeEmail(v){
      if(!v)return false;var local=v.toLowerCase().split('@')[0],tok=local.split(/[^a-z]+/),i,j;
      for(i=0;i<tok.length;i++){if(!tok[i])continue;for(j=0;j<PROF_SUB.length;j++)if(tok[i].indexOf(PROF_SUB[j])>=0)return true;if(PROF_EXACT.indexOf(tok[i])>=0)return true}
      var a=local.replace(/[^a-z0-9]/g,'');if(!a)return false;
      return /^(.)\1{3,}$/.test(a)||JUNK.indexOf(a)>=0||sequentialRun(a)||keyboardWalk(a)||repeatedBlock(a);
    }
    function pretty(d){return d.slice(0,5)+' '+d.slice(5)}
    function padSpot(n){var s=String(n);while(s.length<(cfg.spotPad||5))s='0'+s;return s}
    function demoSpot(){var key='rk_demo_spot_v2',n=NaN;try{n=parseInt(localStorage.getItem(key),10)}catch(e){}if(!isFinite(n))n=Number(cfg.spotStart||247);try{localStorage.setItem(key,String(n+1))}catch(e){}return n}
    function wait(ms){return new Promise(function(r){setTimeout(r,ms)})}
    /* Visible progress on slow mobile connections: spinner + label, aria-busy for screen readers. */
    function setBusy(btn,on,label){
      if(!btn)return;
      if(on){
        if(!btn.hasAttribute('data-label'))btn.setAttribute('data-label',btn.textContent.trim());
        btn.classList.add('is-busy');btn.setAttribute('aria-busy','true');btn.disabled=true;btn.textContent='';
        var sp=document.createElement('span');sp.className='rkl-spin';sp.setAttribute('aria-hidden','true');
        var tx=document.createElement('span');tx.textContent=label;btn.appendChild(sp);btn.appendChild(tx);
      }else{
        btn.classList.remove('is-busy');btn.removeAttribute('aria-busy');btn.disabled=false;
        if(btn.hasAttribute('data-label'))btn.textContent=btn.getAttribute('data-label');
      }
    }

            function apiPost(url,body){
  var ctl=window.AbortController?new AbortController():null,timer=ctl?setTimeout(function(){ctl.abort()},15000):0;
  var form=new URLSearchParams();
  Object.keys(body).forEach(function(k){form.append(k,body[k])});
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},credentials:'same-origin',body:form.toString(),signal:ctl?ctl.signal:undefined})
    .then(function(r){clearTimeout(timer);if(!r.ok){var err=new Error('http');err.status=r.status;throw err;}return r.json()});
}
    function failText(err,fallback){
      if(err&&err.status===429)return t('rateLimit','Too many attempts. Please wait a minute and try again.');
      if(err&&err.name==='AbortError')return t('timeout','The connection timed out. Please try again.');
      return fallback;
    }
    function unavailable(which){
      setMsg(t('unavailable','Signup is not available right now. Please try again later.'));
      if(window.console)console.error('[Rookiez] Demo mode is off but the '+which+' endpoint is empty in the Theme Editor.');
    }

    function resetOtp(){
      otpChallenge='';verifiedToken='';sentPhone='';stopWebOtp();
      if(otpBox)otpBox.hidden=true;if(sendBtn)sendBtn.hidden=false;if(otpInput)otpInput.value='';
      clearInterval(cooldownTimer);
    }
    function startCooldown(){
      cooldown=30;clearInterval(cooldownTimer);
      function tick(){if(!resendBtn)return;if(cooldown<=0){clearInterval(cooldownTimer);resendBtn.disabled=false;resendBtn.textContent=t('resend','Resend code');return}resendBtn.disabled=true;resendBtn.textContent=t('resendIn','Resend in')+' '+cooldown+'s';cooldown--}
      tick();cooldownTimer=setInterval(tick,1000);
    }
    function stopWebOtp(){if(webOtp){try{webOtp.abort()}catch(e){}webOtp=null}}
    function listenWebOtp(){/* OTP removed in the email-first build; no-op */}

    /* Record the lead in Shopify natively (no app, no token): the storefront customer form.
       Posts email-first to /contact (form_type=customer) so it creates/subscribes a customer.
       Phone + layer ride along as tags so they're searchable/segmentable in admin. */
            function postToShopify(email,phone,layerName){
      return fetch('/contact',{credentials:'same-origin'})
        .then(function(r){return r.text()})
        .then(function(html){
          var match=html.match(/name="authenticity_token"\s+value="([^"]+)"/);
          var token=match?match[1]:'';
          var body=new URLSearchParams();
          body.set('form_type','contact');
          body.set('utf8','\u2713');
          body.set('authenticity_token',token);
          body.set('contact[email]',email);
          body.set('contact[body]','Founders drop signup');
          return fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},credentials:'same-origin',redirect:'manual',body:body.toString()})
            .then(function(r){
              if(r.status===200||r.status===302||r.type==='opaqueredirect'){return{}}
              var err=new Error('http');err.status=r.status;throw err;
            });
        });
    }
    /* The Founder number: a display-only counter. Not tied to the customer; may drift. */
    function getNumber(){
  if(demo)return Promise.resolve(demoSpot());
  if(!cfg.counterUrl){unavailable('counter');return Promise.reject(Object.assign(new Error('config'),{quiet:true}))}
  var email=(emailInput&&emailInput.value||'').trim().toLowerCase();
  var phone=normalizePhone(phoneInput.value);
  var l=layers[selected]||layers[0];
  return apiPost(cfg.counterUrl,{email:email,phone:phone,layer:l.name||''}).then(function(d){var n=Number(d&&d.spot_number);if(!isFinite(n)||n<=0)throw new Error('spot');return n});
}

    function joinNow(){
      if(busy)return;
      if((q('[name="company"]')||{}).value)return; /* honeypot: ignore bots silently */
      var phone=normalizePhone(phoneInput.value);phoneInput.value=phone;
      var email=(emailInput&&emailInput.value||'').trim();
      if(!email||!validEmail(email)){setMsg(t('email','Enter a valid email address.'));if(emailInput){emailInput.setAttribute('aria-invalid','true');emailInput.focus()}track('validation_error',{field:'email',reason:'format'});return}
      if(fakeEmail(email)){setMsg(t('emailFake','Please use a real email address.'));emailInput.setAttribute('aria-invalid','true');emailInput.focus();track('validation_error',{field:'email',reason:'junk'});return}
      emailInput.removeAttribute('aria-invalid');
      if(phone&&!validPhone(phone)){setMsg(t('phone','Enter a valid 10-digit Indian mobile number, or leave it blank.'));phoneInput.setAttribute('aria-invalid','true');phoneInput.focus();track('validation_error',{field:'phone',reason:'format'});return}
      if(phone&&fakePhone(phone)){setMsg(t('phoneFake','Enter a real mobile number, or leave it blank.'));phoneInput.setAttribute('aria-invalid','true');phoneInput.focus();track('validation_error',{field:'phone',reason:'pattern'});return}
      phoneInput.removeAttribute('aria-invalid');
      if(!consentInput.checked){setMsg(t('consent','Please tick the box to agree to launch updates.'));consentInput.focus();return}
      busy=true;setBusy(sendBtn,true,t('sending','Joining…'));setMsg('');
      var l=layers[selected]||layers[0];
      track('signup_submitted',{method:'email',layer_index:selected+1,layer_name:l.name});
      var rec=demo?Promise.resolve():postToShopify(email.toLowerCase(),phone,l.name).catch(function(){/* best-effort record; still show the number */});
      rec.then(function(){return getNumber().catch(function(){return 247})}).then(function(n){sentPhone=phone;showSuccess(n)}).catch(function(err){
        if(err&&err.quiet)return;
        setMsg(failText(err,t('joinFail','We could not finish your signup. Please try again.')));track('signup_failed',{method:'email'});
      }).then(function(){busy=false;setBusy(sendBtn,false)});
    }

    if(sendBtn)sendBtn.addEventListener('click',function(e){e.preventDefault();joinNow()});
    if(form)form.addEventListener('submit',function(e){e.preventDefault();joinNow()});
    if(phoneInput)phoneInput.addEventListener('input',function(){
      var raw=phoneInput.value,d=digits(raw);
      if(d.length>10||/[^\d\s]/.test(raw.replace(/^\+/,''))){var n=normalizePhone(raw);if(n!==raw)phoneInput.value=n}
      if(sentPhone&&normalizePhone(phoneInput.value)!==sentPhone){resetOtp();setMsg(t('numberChanged','Number changed. Send a new code.'),'ok')}
    });
    if(emailInput)emailInput.addEventListener('input',function(){emailInput.removeAttribute('aria-invalid')});
    if(otpInput)otpInput.addEventListener('input',function(){var v=digits(otpInput.value).slice(0,6);if(v!==otpInput.value)otpInput.value=v});

    /* ---------- Success: bag replaces the form in place, then turns ---------- */
    var success=q('[data-success]'),successHeading=q('[data-success-heading]'),successNumber=q('[data-success-number]'),bag=q('[data-bag]'),bagDrop=q('[data-bag-drop]'),bagStage=q('[data-bag-stage]'),bagNumber=q('[data-bag-number]'),revealTimer=0,doneTimer=0;
    function whenBrandReady(cb){var mark=q('img.rkl-bag__mark'),done=false;function go(){if(!done){done=true;cb()}}if(!mark||mark.complete){go();return}mark.addEventListener('load',go,{once:true});mark.addEventListener('error',go,{once:true});setTimeout(go,1200)}
    var contactLine=q('[data-success-contact]'),shareNative=q('[data-share-native]'),shareWa=q('[data-share-wa]'),shareCopy=q('[data-share-copy]'),shareData=null;
    function shareUrl(){
      var u=cfg.shareUrl||(location.origin+location.pathname);
      try{var x=new URL(u,location.href);x.hash='';x.searchParams.set('utm_source','founder_share');x.searchParams.set('utm_medium','referral');return x.toString()}catch(e){return u}
    }
    function setupShare(num){
      var text=t('shareText','I just got my Founder number [number] for LAYERS by Rookiez Life. Get yours before launch:');
      text=text.indexOf('[number]')>=0?text.split('[number]').join(num):text;
      shareData={title:t('shareTitle','Founders\' Drop - LAYERS by Rookiez Life'),text:text,url:shareUrl()};
      if(shareWa)shareWa.href='https://wa.me/?text='+encodeURIComponent(shareData.text+' '+shareData.url);
      var canNative=!!(navigator.share&&(!navigator.canShare||navigator.canShare({url:shareData.url})));
      if(shareNative)shareNative.hidden=!canNative;
      if(shareCopy)shareCopy.hidden=canNative||!(navigator.clipboard&&window.isSecureContext);
    }
    if(shareNative)shareNative.addEventListener('click',function(){if(!shareData)return;navigator.share(shareData).then(function(){track('share_completed',{channel:'native'})}).catch(function(){});track('share_clicked',{channel:'native'})});
    if(shareWa)shareWa.addEventListener('click',function(){track('share_clicked',{channel:'whatsapp'})});
    if(shareCopy)shareCopy.addEventListener('click',function(){if(!shareData)return;navigator.clipboard.writeText(shareData.url).then(function(){var l=shareCopy.getAttribute('data-label')||shareCopy.textContent;shareCopy.setAttribute('data-label',l);shareCopy.textContent=t('copied','Link copied');setTimeout(function(){shareCopy.textContent=l},2200)}).catch(function(){});track('share_clicked',{channel:'copy'})});
    function showSuccess(n){
      var f='No. '+padSpot(n);if(successNumber)successNumber.textContent=f;if(bagNumber)bagNumber.textContent=f;
      if(contactLine){var em=(emailInput&&emailInput.value||'').trim().toLowerCase();var ph=sentPhone?(' '+t('andSms','and text you at')+' +91 '+pretty(sentPhone)):'';contactLine.textContent=(em?t('sentToEmail',"We'll email you at")+' '+em:t('onList',"You're on the list"))+ph+'.'}
      setupShare(f);
      var anchorTop=(form&&signup&&!signup.hidden)?form.getBoundingClientRect().top:null;
      signupDone=true;signup.hidden=true;success.hidden=false;success.classList.remove('is-done');
      qa('[data-open-signup]').forEach(function(b){b.hidden=true});
      if(anchorTop!==null&&bagStage){var delta=bagStage.getBoundingClientRect().top-anchorTop;if(Math.abs(delta)>1)scrollByInstant(delta)}
      ensureVisible(bagStage);
      if(successHeading)successHeading.focus({preventScroll:true});
      clearTimeout(revealTimer);clearTimeout(doneTimer);
      bag.classList.remove('is-revealed');bagDrop.classList.remove('is-in');void bagDrop.offsetWidth;bagDrop.classList.add('is-in');
      var r=reduced();
      whenBrandReady(function(){revealTimer=setTimeout(function(){bag.classList.add('is-revealed');doneTimer=setTimeout(function(){success.classList.add('is-done')},r?0:1050)},r?0:1100)});
      track('signup_success',{method:'phone',spot_number:padSpot(n)});track('spot_reserved',{spot_number:padSpot(n)});
    }

    /* ---------- Legal modal ---------- */
    var dlg=q('[data-modal]'),mBody=q('[data-modal-body]'),mTitle=q('[data-modal-title]'),lastTrigger=null;
    qa('[data-legal]').forEach(function(link){link.addEventListener('click',function(e){
      var kind=link.getAttribute('data-legal'),tpl=q('[data-legal-'+kind+']');
      if(!dlg||!tpl||typeof dlg.showModal!=='function')return; /* falls back to the link's own href */
      e.preventDefault();
      mTitle.textContent=link.getAttribute('data-legal-title')||(kind==='privacy'?'Privacy Policy':'Founders\' Drop Terms');
      mBody.innerHTML=tpl.innerHTML;lastTrigger=link;dlg.showModal();mBody.scrollTop=0;
      track('legal_opened',{doc:kind});
    })});
    if(dlg){
      var closeBtn=q('[data-close]',dlg);if(closeBtn)closeBtn.addEventListener('click',function(){dlg.close()});
      dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
      dlg.addEventListener('close',function(){if(lastTrigger)lastTrigger.focus({preventScroll:true})});
    }

    /* ---------- Theme Editor: selecting a Layer block opens it ---------- */
    root.__rkl={selectBlock:function(el){var i=cards.indexOf(el);if(i<0)return;openFan();openLayer(i,{scroll:false})}};

    /* ---------- Founder note: highlight sweeps in once, when the note is on screen ---------- */
    var note=q('[data-founder-note]');
    if(note&&note.classList.contains('rkl-founder--marker')){
      if(reduced()||!('IntersectionObserver' in window)){note.classList.add('is-inview')}
      else{root.classList.add('rkl-note-anim');var noteIO=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){note.classList.add('is-inview');noteIO.disconnect()}})},{rootMargin:'0px 0px -15% 0px',threshold:.35});noteIO.observe(note)}
    }

    track('page_viewed',{});
    requestAnimationFrame(function(){root.classList.add('rkl-lit')});
  }

  function initAll(scope){Array.prototype.forEach.call((scope||document).querySelectorAll('[data-rkl-root]'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll()});else initAll();
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
  document.addEventListener('shopify:block:select',function(e){var r=e.target&&e.target.closest?e.target.closest('[data-rkl-root]'):null;if(r&&r.__rkl)r.__rkl.selectBlock(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
